import { animate, AUTO_STYLE, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

type Color = 'primary' | 'secondary' | 'tertiary';

@Component({
    selector: 'ui-collapse',
    templateUrl: './collapse.component.html',
    styleUrls: ['./collapse.component.scss'],
    animations: [
        trigger('open', [
            state('true', style({ height: AUTO_STYLE })),
            state('false', style({ height: '0px' })),
            transition('false => true', animate('250ms ease-in-out')),
            transition('true => false', animate('250ms ease-in-out'))
        ])
    ],
    standalone: false
})
export class CollapseComponent {
  @Input('p-title') title: string;
  @Input('p-color') color: Color  = 'tertiary';
  @Input('p-is-sub-collapse') isSubCollapse: boolean = false;
  public open: boolean = false;

  toggle() {
    this.open = !this.open;
  }
}
